import { Shell } from "../ui/Shell";
import { Link } from "react-router";
import { Notice } from "../ui";
import { useIch } from "../api/ich";

export function AdminShell() {
  const ich = useIch();
  return (
    <Shell
      brand="MeinRegalladen"
      kontext={`Anbieter · ${ich.data?.benutzer?.name || ich.data?.benutzer?.email || ""}`}
      gruppen={[
        {
          eintraege: [
            { to: "/admin", label: "Läden", icon: "store", end: true },
            { to: "/admin/betrieb", label: "Betrieb", icon: "shield-check" },
            { to: "/admin/postfach", label: "Dev-Postfach", icon: "inbox" },
            { to: "/admin/rechtliches", label: "Rechtliches", icon: "file-text" },
            { to: "/admin/konto", label: "Mein Konto", icon: "user" },
          ],
        },
      ]}
      hinweis={
        ich.data?.totpPflicht && !ich.data.totpAktiv ? (
          <Notice tone="attention" title="Zwei-Faktor-Anmeldung einrichten" action={<Link to="/admin/konto" className="rg-btn rg-btn--primary">Jetzt einrichten</Link>}>
            Für den Anbieter ist der zweite Faktor Pflicht. Bis zur Einrichtung sind die Admin-Funktionen gesperrt.
          </Notice>
        ) : null
      }
    />
  );
}
